import React from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import "./SideNav.scss";
import { RootState } from "../../redux/rootReducers";
import {
  AllGroupMenuType,
  LoginResponseType,
} from "../../redux/auth/authTypes";
import {
  ServicesActive,
  ServicesInactive,
  AssignColumnsActive,
  AssignColumnsInactive,
  InvoiceColumnsInactive,
  InvoiceColumnsActive,
  AssignClientsActive,
  AssignClientsInactive,
  OpenItemsActive,
  OpenItemsInactive,
  AdminReportsActive,
  AdminReportsInactive,
  UsersClientsActive,
  UsersClientsInactive,
  ChangeCredentialsActive,
  ChangeCredentialsInactive,
  HomeActive,
  HomeInactive,
  UserManagementInactive,
  UserManagementActive,
  OpenJobsActive,
  OpenJobsInactive,
  IdPasswordActive,
  IdPasswordInactive,
  MaintenanceInactive,
  MaintenanceActive,
  DisbursementActiveIcon,
  DisbursementInactiveIcon,
  ClientDirectoryInActiveIcon,
  ClientDirectoryActiveIcon,
  MasterDataActiveIcon,
  MasterDataInActiveIcon,
  TimeSheetActiveIcon,
  TimeSheetInActiveIcon,
  DoubleArrow,
  ProjExelLogo,
  FinacLogoSmall,
  TimeSheetReportActiveIcon,
  TimeSheetReportInActiveIcon,
  JobsInactiveIcon,
  JobsActiveIcon,
  ComplianceCalendarIcon,
  ComplianceCalendarActiveIcon,
  LeadModuleActiveIcon,
  LeadModuleInActiveIcon,
  HelpModuleIcon,
  HelpModuleActiveIcon,
  SchedulingActiveIcon,
  SchedulingIcon,
  HRMSIcon,
  HRMSActiveIcon,
  ThinksToDoInactiveIcon,
  ThinksToDoActiveIcon,
  TeamDirectoryActiveIcon,
  TeamDirectoryInActiveIcon,
  OfficerDirectoryActiveIcon,
  OfficerDirectoryInactiveIcon

} from "../../assets/images";
import {
  ADMIN_MENU,
  USER_MENU,
  EXTRA_MENU,
  EXTERNAL_MENU,
  CLIENT_MENU,
} from "../../constant/menu";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type AppProps = {
  loginData: LoginResponseType;
  name?: string;
  sideMenus: any[];
  allGroupMenus: [] | AllGroupMenuType[];
  toggle: boolean;
  handleToggle: any;
};

const SideNav = ({
  loginData,
  name,
  sideMenus,
  allGroupMenus,
  toggle,
  handleToggle,
}: AppProps) => {
  const { user_role_id, is_client } = loginData;
  const getMenuList = () => {
    switch (user_role_id) {
      case 1:
        return ADMIN_MENU;
      default:
        if (is_client === 0) {
          return USER_MENU;
        } else {
          return CLIENT_MENU;
        }
    }
  };

  const returnIcon = (iconName: string) => {
    switch (iconName) {
      case "HomeInactive":
        return HomeInactive;
      case "HomeActive":
        return HomeActive;
      case "ServicesActive":
        return ServicesActive;
      case "ServicesInactive":
        return ServicesInactive;
      case "AssignColumnsInactive":
        return AssignColumnsInactive;
      case "AssignColumnsActive":
        return AssignColumnsActive;
      case "InvoiceColumnsInactive":
        return InvoiceColumnsInactive;
      case "InvoiceColumnsActive":
        return InvoiceColumnsActive;
      case "AssignClientsInactive":
        return AssignClientsInactive;
      case "AssignClientsActive":
        return AssignClientsActive;
      case "OpenItemsInactive":
        return OpenItemsInactive;
      case "OpenItemsActive":
        return OpenItemsActive;
      case "AdminReportsInactive":
        return AdminReportsInactive;
      case "AdminReportsActive":
        return AdminReportsActive;
      case "UsersClientsInactive":
        return UsersClientsInactive;
      case "UsersClientsActive":
        return UsersClientsActive;
      case "ChangeCredentialsInactive":
        return ChangeCredentialsInactive;
      case "ChangeCredentialsActive":
        return ChangeCredentialsActive;
      case "UserManagementInactive":
        return UserManagementInactive;
      case "UserManagementActive":
        return UserManagementActive;
      case "OpenJobsActive":
        return OpenJobsActive;
      case "OpenJobsInactive":
        return OpenJobsInactive;
      case "IdPasswordActive":
        return IdPasswordActive;
      case "IdPasswordInactive":
        return IdPasswordInactive;
      case "MaintenanceInactive":
        return MaintenanceInactive;
      case "MaintenanceActive":
        return MaintenanceActive;
      case "DisbursementActiveIcon":
        return DisbursementActiveIcon;
      case "DisbursementInactiveIcon":
        return DisbursementInactiveIcon;
      case "ClientDirectoryActiveIcon":
        return ClientDirectoryActiveIcon;
      case "ClientDirectoryInActiveIcon":
        return ClientDirectoryInActiveIcon;
      case "activeMasterIcon":
        return MasterDataActiveIcon;
      case "inActiveMasterIcon":
        return MasterDataInActiveIcon;
      case "TimeSheetActiveIcon":
        return TimeSheetActiveIcon;
      case "TimeSheetInActiveIcon":
        return TimeSheetInActiveIcon;
      case "TimeSheetReportActiveIcon":
        return TimeSheetReportActiveIcon;
      case "TimeSheetReportInActiveIcon":
        return TimeSheetReportInActiveIcon;
      case "JobsInactiveIcon":
        return JobsInactiveIcon;
      case "JobsActiveIcon":
        return JobsActiveIcon;
      case "ComlianceCalendarIcon":
        return ComplianceCalendarIcon;
      case "ComlianceCalendarActiveIcon":
        return ComplianceCalendarActiveIcon;
      case "LeadModuleActiveIcon":
        return LeadModuleActiveIcon;
      case "LeadModuleInActiveIcon":
        return LeadModuleInActiveIcon;
      case "HelpModuleIcon":
        return HelpModuleIcon;
      case "HelpModuleActiveIcon":
        return HelpModuleActiveIcon;
      case "SchedulingActiveIcon":
        return SchedulingActiveIcon;
      case "SchedulingIcon":
        return SchedulingIcon;
      case "HRMSIcon":
        return HRMSIcon;
      case "HRMSActiveIcon":
        return HRMSActiveIcon;
      case "ThinksToDoInactiveIcon":
        return ThinksToDoInactiveIcon;
      case "ThinksToDoActiveIcon":
        return ThinksToDoActiveIcon;
      case "TeamDirectoryActiveIcon":
        return TeamDirectoryActiveIcon;
      case "TeamDirectoryInActiveIcon":
        return TeamDirectoryInActiveIcon;
      case "OfficerDirectoryActiveIcon":
        return OfficerDirectoryActiveIcon;
      case "OfficerDirectoryInactiveIcon":
        return OfficerDirectoryInactiveIcon;
      default:
        return "";
    }
  };

  const menuList =
    sideMenus?.length > 0 &&
    sideMenus?.map((link: any, index: number) => {
      return (
        <li key={`${index}${link}`}>
          {!toggle ? (
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 250 }}
              overlay={
                <Tooltip id="button-view-open-item">{link.menu_name}</Tooltip>
              }
            >
              <NavLink
                to={link.front_end_route}
                exact
                activeClassName={name === link.finac_key ? "active" : ""}
                style={{ cursor: "pointer" }}
              >
                {name === link.finac_key ? (
                  <img src={returnIcon(link.active_icon)} />
                ) : (
                  <img src={returnIcon(link.icon)} />
                )}
                {toggle && (
                  <span
                    className={`ml-3 ${link.comingSoon ? "text-muted" : null}`}
                  >
                    {link.menu_name}
                  </span>
                )}
                <br />
              </NavLink>
            </OverlayTrigger>
          ) : (
            <NavLink
              to={link.front_end_route}
              exact
              activeClassName={name === link.finac_key ? "active" : ""}
              style={{ cursor: "pointer" }}
            >
              {name === link.finac_key ? (
                <img src={returnIcon(link.active_icon)} alt="active icon" />
              ) : (
                <img src={returnIcon(link.icon)} alt="link icon" />
              )}
              {toggle && (
                <span
                  className={`ml-3 ${link.comingSoon ? "text-muted" : null}`}
                >
                  {link.menu_name}
                </span>
              )}
               {link.is_new ? <span className='new-chip'>New</span> : null}  
              <br />
            </NavLink>
          )}
        </li>
      );
    });

  const extraMenuList = EXTRA_MENU.map((link: any, index: number) => {
    return (
      <li key={`${index}${link}`}>
        {!toggle ? (
          <OverlayTrigger
            placement="right"
            delay={{ show: 250, hide: 250 }}
            overlay={<Tooltip id="button-view-open-item">{link.title}</Tooltip>}
          >
            <NavLink
              to={link.to}
              exact
              activeClassName={name === link.key ? "active" : ""}
              style={{ cursor: "pointer" }}
            >
              {/* <i className={link.icon}></i> */}
              <img
                src={name === link.key ? link.activeIcon : link.icon}
                alt="link icon"
              />
              {/* // <i className={link.icon}></i> */}

              {toggle && <span className="ml-3">{link.title}</span>}
            </NavLink>
          </OverlayTrigger>
        ) : (
          <NavLink
            to={link.to}
            exact
            activeClassName={name === link.key ? "active" : ""}
            style={{ cursor: "pointer" }}
          >
            <img
              src={name === link.key ? link.activeIcon : link.icon}
              alt="active icon"
            />
            {toggle && <span className={`ml-3`}>{link.title}</span>}
            <br />
          </NavLink>
        )}
      </li>
    );
  });
  const filteredMenu = EXTERNAL_MENU.filter((link) => {
    if (loginData?.user_type === 1) {
      return true; 
    } else {
      return link?.title !== 'Manual' && link?.title !== 'STCO Portal';
    }
  });
  const externalMenuList = filteredMenu?.map((link: any, index: number) => {
    return (
      <li key={index}>
        {!toggle ? (
          <OverlayTrigger
            placement="right"
            delay={{ show: 250, hide: 250 }}
            overlay={<Tooltip id="button-view-open-item">{link.title}</Tooltip>}
          >
            <a
              href={link.externalLink}
              target="_blank"
              style={{ cursor: "pointer" }}
            >
              {link.icon}
              {toggle && link.title}
            </a>
          </OverlayTrigger>
        ) : (
          <a href={link.externalLink} target="_blank" style={{ cursor: "pointer" }}>
            {link.icon}
            <span className="ml-3">{toggle && link.title}</span>
          </a>
        )}
      </li>
    );
  });

  return (
    <div className="sidebar-menu">
      <ul>
        {!toggle && (
          <li style={{ display: "flex", justifyContent: "center" }}>
            {!toggle && (
              <img
                src={FinacLogoSmall}
                alt="ProjExel Logo"
                className="logo mt-0"
                style={{ width: !toggle ? "32px" : "" }}
              />
            )}
          </li>
        )}
        <li
          style={{
            display: "flex",
            justifyContent: toggle ? "space-between" : "center",
          }}
          className={toggle ? "mb-3" : ""}
        >
          {toggle && (
            <img
              src={toggle ? ProjExelLogo : FinacLogoSmall}
              alt="ProjExel Logo"
              className="logo mt-3"
              style={{ width: !toggle ? "32px" : "" }}
            />
          )}
          {toggle && (
            <img
              src={DoubleArrow}
              alt="arror Logo"
              className={`${toggle ? "arrowRight md-3" : " mt-4"} mr-3 `}
              style={{ cursor: "pointer", marginTop: toggle ? "30px" : "" }}
              onClick={() => handleToggle()}
            />
          )}
          {!toggle && (
            <img
              src={DoubleArrow}
              alt="arror Logo"
              className={`${toggle ? "arrowRight" : " mt-3"} mr-2 mb-3`}
              style={{ cursor: "pointer", marginTop: toggle ? "30px" : "" }}
              onClick={() => handleToggle()}
            />
          )}
        </li>
        {menuList}
      </ul>
      <hr />
      <ul>
        {extraMenuList}
        {externalMenuList}
      </ul>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  loginData: state.auth.loginData,
  sideMenus: state.auth.sideMenus,
  allGroupMenus: state.auth.allGroupMenus,
});

export default connect(mapStateToProps)(SideNav);
